import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import ColorPicker from "./ColorPicker";
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, MOBILE_INTERACTIVE_BANNER_AD_FIELDS } from "./definitions";
import InputTextSection from "./InputTextSection";
import { useSelector } from "react-redux";
import VideoAssetCreativeType from "./VideoAssetCreativeType";
import BaseCreativeControls from "./BaseCreativeControls";
import DropdownSection from "./DropdownSection";

const CREATIVE_TYPE = CREATIVE_NAMES.MOBILE_INTERACTIVE_BANNER;
const SIZE_OPTIONS = [
    {label: "320x100", value: "320x100"},
    {label: "300x100", value: "300x100"},
    {label: "300x250", value: "300x250"},
    {label: "336x280", value: "336x280"},
    {label: "300x600", value: "300x600"}
]

export default function MobileInteractiveBanner({
    bannerUrl,
    videoCreativeUrl,
    container,
    btnText,
    bgColor,
    hoverBgColor,
    color,
    hoverColor,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    left,
    bottom,
    vastUrl,
    vastDuration,
    videoCreativeType,
    adServingType,
    creativeSize,
    ctaWidth,
    ctaHeight
}) {
    const { isAdmin } = useSelector((state) => state.userInformation);
    
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <VideoAssetCreativeType
                    dropdownLabel="Video Creative Type"
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType || 'video'}
                    handleChange={handleChange}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel="Video URL"
                    videoUrlInputName={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.videoCreativeUrl}
                    videoUrl={videoCreativeUrl}
                    vastUrl={vastUrl}
                    vastInputName={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.vastUrl}
                    vastDurationInputName={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />
                <DropdownSection
                    label="Creative image size"
                    optionLabel="label"
                    optionValue="value"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.creativeSize}
                    value={creativeSize}
                    options={SIZE_OPTIONS}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
                <AssetInputOrUploadSection
                    inputValue={bannerUrl}
                    inputLabel="Main creative image"
                    inputName={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.bannerUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <InputTextSection
                    label="Container"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.container}
                    value={container}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    uriEncodeValue={false}
                />
                <InputTextSection
                    label="CTA button text"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.btnText}
                    value={btnText}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    uriEncodeValue={false}
                />
                <InputTextSection
                    label="CTA button width px (optional)"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.ctaWidth}
                    value={ctaWidth}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    isNumericInput={true}
                />
                <InputTextSection
                    label="CTA button height px (optional)"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.ctaHeight}
                    value={ctaHeight}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    isNumericInput={true}
                />
                {isAdmin && (
                    <>
                        <InputTextSection
                            label="CTA left coords (optional)"
                            name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.left}
                            value={left}
                            changeHandler={handleChange}
                            adtype={CREATIVE_TYPE}
                            uriEncodeValue={false}
                        />
                        <InputTextSection
                            label="CTA bottom coords (optional)"
                            name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.bottom}
                            value={bottom}
                            changeHandler={handleChange}
                            adtype={CREATIVE_TYPE}
                            uriEncodeValue={false}
                        />
                    </>
                )}
                <ColorPicker
                    label="CTA button text color"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.color}
                    value={color}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
                <ColorPicker
                    label="CTA button text hover color"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.hoverColor}
                    value={hoverColor}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
                <ColorPicker
                    label="CTA button background color"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.bgColor}
                    value={bgColor}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
                <ColorPicker
                    label="CTA button hover color"
                    name={MOBILE_INTERACTIVE_BANNER_AD_FIELDS.hoverBgColor}
                    value={hoverBgColor}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
            </BaseCreativeControls>
        </>
    );
}
